/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import Header from "@/src/components/Header/Header";
import React from "react";
import HeaderActionsAuthenticated from "@/src/components/HeaderActionsAuthenticated/HeaderActionsAuthenticated";
import AuthenticatedNavigation from "@/src/components/AuthenticatedNavigation/AuthenticatedNavigation";
import { layoutAuthenticatedStyle } from "@/src/containers/Layouts/layoutAuthenticatedStyle";


export const LayoutHeaderAuthenticated = () => {
  return (
    <Header
      logoLink={{ label: "Zur Servicewelt", to: "/servicewelt" }}
      actions={<HeaderActionsAuthenticated />}
      mobileNavComp={<AuthenticatedNavigation sx={layoutAuthenticatedStyle.navigationMobile} />}
    />
  );
};
